<template></template>

<script setup>
import gsap from "gsap";
var bubbleId = 1;
function genRand(min, max, decimalPlaces) {
  var rand = Math.random() * (max - min) + min;
  var power = Math.pow(10, decimalPlaces);
  return Math.floor(rand * power) / power;
}
function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}
$(document).ready(function () {
  

  function createBubble() {
    $(".animation-wrapper").append('<div class="bubbles" style="left:' + genRand(0, 90, 0) + '%; top:' + genRand(0, 90, 0) + '%"></div>');
    if (bubbleId < 10) {
      setTimeout(function () {
        createBubble();
      }, 500);
      $(".bubbles").append(
        '<img src="hero/bubble.png" class="bubble-new" data-id="' +
          bubbleId +
          '" style="left: ' +
          genRand(10, 100, 0) +
          "px; width: " +
          genRand(5, 15, 0) +
          'px"/>'
      );

      let object = {
        duration: genRand(3, 7, 1),
        el: '.bubble-new[data-id="' + bubbleId + '"]',
      };

      var bubble = gsap.timeline({
        onComplete: function () {
          $(object.el).remove();
        },
      });

      bubble.fromTo(
        object.el,
        {
          delay: 0.5,
          y: genRand(50, 200, 0),
          x: 0,
          scale: 1.5,
          transformOrigin: "center",
        },
        {
          duration: object.duration,
          y: "-=" + genRand(100, 200, 0),
          x: Math.PI * genRand(1, 2, 1),
          modifiers: {
            x: function (x) {
              return Math.sin(parseFloat(x)) * 30 + "px";
            },
          },
          scale: 0,
        }
      );
      gsap.fromTo(
        object.el,
        { opacity: 0 },
        { opacity: genRand(0.6, 1, 1), duration: 1 }
      );
      bubbleId++;
    } else {
      bubbleId = 1;
      setTimeout(function() {
        $('.bubbles').remove();
        createBubble();
      }, 4000)
    }
  }
  createBubble();
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.bubbles {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: -1;
}

.bubble-new {
  opacity: 1;
  position: absolute;
  mix-blend-mode: screen;
}
</style>
